module.exports = __webpack_public_path__ + "static/assets/e7bb52546976d9049d814cf350d3da13.png";